const initState=0;
const PracticeIDReducer = (state = initState, action) => {
    switch(action.type) {
        case  'PracticeID' : return  action.payload ;
        default: return state;
    }
}
export default PracticeIDReducer;